import PersonIcon from '@material-ui/icons/Person';

import AccountOwnerList from './AccountOwnerList';

export default {
    list: AccountOwnerList,
    icon: PersonIcon,
};
